




































import LazyHydrate from 'vue-lazy-hydration';
import { useRoute, defineComponent, onMounted } from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { SfImage } from '~/components/StorefrontUi';
import { usePayuMethodsStore } from '~/modules/checkout/stores/payuMethods';
import SecondaryFooter from '~/components/SecondaryFooter/SecondaryFooter.vue';
import { loadCartMixin } from '~/mixins/loadCartMixin';

export default defineComponent({
  name: 'CheckoutLayout',
  components: {
    SfImage,
    LazyHydrate,
    SecondaryFooter,
    Notification: () => import(/* webpackPrefetch: true */ '~/components/Notification.vue'),
    HeaderSteps: () => import(
      /* webpackPrefetch: true */ '~/modules/checkout/components/HeaderSteps.vue'
    ),
  },
  setup() {
    loadCartMixin();
    const route = useRoute();
    const { loadPayuMethods } = usePayuMethodsStore();

    onMounted(async () => {
      await loadPayuMethods();
    });

    return {
      route,
      addBasePath,
    };
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
});
